import { css } from '@emotion/css';
import { baseTheme } from '@streamlain/theme';

export const textStyle = css({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--streamlain-font-base)',
  lineHeight: 'var(--streamlain-line-height)',
  color: 'var(--streamlain-v2-text-primary)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  overflow: 'var(--dv-cell-overflow, hidden)',
  textOverflow: 'var(--dv-cell-text-overflow, ellipsis)',
  whiteSpace: 'var(--dv-cell-white-space, nowrap)',
});

export const textInputStyle = css({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  fontSize: 'var(--streamlain-font-base)',
  lineHeight: 'var(--streamlain-line-height)',
  color: 'var(--streamlain-v2-text-primary)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  cursor: 'text',
  overflow: 'var(--dv-cell-overflow, hidden)',
  textOverflow: 'var(--dv-cell-text-overflow, ellipsis)',
  whiteSpace: 'var(--dv-cell-white-space, nowrap)',
  ':focus': {
    outline: 'none',
  },
});
